/**
 * Ported from the Angular HRM app's shared/constant/employment-types.constant.ts.
 */
export const EMPLOYMENT_TYPES: string[] = [
  'Internship',
  'Probation',
  'Part Time',
  'Full Time',
  'Contractual',
  'Notice Period',
  'External Consultant',
];
